import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormationsFormComponent } from './formations-form/formations-form/formations-form.component';
import { ManageFormationsTableComponent } from './manage-formations-table/manage-formations-table/manage-formations-table.component';
import { FormationsService } from '../../../../services/formations.service';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-manage-formations',
  standalone: true,
  imports: [
    CommonModule,
    FormationsFormComponent,
    ManageFormationsTableComponent
  ],
  templateUrl: './manage-formations.component.html',
  styleUrls: ['./manage-formations.component.scss']
})
export class ManageFormationsComponent {
  private formationsService = inject(FormationsService);
  private messageService = inject(MessageService);
  @ViewChild(ManageFormationsTableComponent)
  table!: ManageFormationsTableComponent;
  selectedFormation: any | null = null;
  onCreate(formData: any) {
    this.formationsService.createFormation(formData).subscribe({
      next: () => {
        this.table?.load();
        this.messageService.add({
          severity: 'success',
          summary: 'Formation créée',
          detail: 'La formation a été créée avec succès',
          life: 5000
        });
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors de la création de la formation',
          life: 5000
        });
      }
    });
  }
}
